import { Component, OnInit } from '@angular/core';
import * as xlsx from 'xlsx';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-import-doc-items',
  templateUrl: './import-doc-items.component.html',
  styleUrls: ['./import-doc-items.component.less'],
})
export class ImportDocItemsComponent implements OnInit {
  itemsToImport: any[] = [];
  fieldsToImport: string[] = [];
  arrayBuffer: ArrayBuffer;
  withHeaders = true;
  attachedFile: any;

  constructor(private drawerRef: NzDrawerRef) {}

  ngOnInit(): void {}

  readXlsxFile(file) {
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    let arrayList: any[] = [];
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result as ArrayBuffer;
      const data = new Uint8Array(this.arrayBuffer);
      const arr = new Array();
      for (let index = 0; index < data.length; index++) {
        arr[index] = String.fromCharCode(data[index]);
      }
      const bstr = arr.join('');
      const workbook = xlsx.read(bstr, { type: 'binary' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // console.log(xlsx.utils.sheet_to_json(worksheet, { raw: true }));
      arrayList = xlsx.utils.sheet_to_json(worksheet, {
        raw: true,
        header: 1,
      }) as Array<any>;
      /*if (arrayList.length > 0) {
        const firstElement = arrayList[0][0] as string;
        if (firstElement.toLowerCase() === 'itemcode') {
          arrayList.shift();
        }
      }
      if (arrayList.length > 1) {
        arrayList.shift();
      }*/

      this.fieldsToImport = arrayList[0];
      arrayList.shift();
      let index = 0;
      arrayList.forEach((row) => {
        this.itemsToImport[index++] = row;
      });
    };
  }

  handleChange(event): void {
    console.log(event);
    const files = event.srcElement.files;
    if (
      files[0].type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      this.readXlsxFile(files[0]);
    } else {
      const reader = new FileReader();
      reader.readAsText(files[0]);
      reader.onload = () => {
        const data = reader.result as string;
        const dataArray = data.split(/\r\n|\n/);
        const records = this.getFileRecords(dataArray);
        this.itemsToImport = Object.assign([], records);
        console.log(records);
      };
    }

    this.drawerRef.close();
  }

  getFileRecords(dataArray: string[], fromText: boolean = false) {
    const tmpArr: any[] = [];
    const startingIndex = this.withHeaders && !fromText ? 1 : 0;
    for (let i = startingIndex; i < dataArray.length; i++) {
      //const currentRecord = dataArray[i].split(fromText ? '\t' : ',');
      const currentRecord = this.splitLine(dataArray[i], fromText);
      if (
        currentRecord == null ||
        (currentRecord.length === 1 && currentRecord[0] === '')
      ) {
        continue;
      }

      if (currentRecord.length === 2) {
        const itemToImport: any = {
          ItemCode: currentRecord[0].trim(),
          ItemName: '',
          Quantity: +currentRecord[1].trim(),
        };
        tmpArr.push(itemToImport);
      } else {
        console.log(currentRecord);

        const itemToImport: any = {
          ItemCode: currentRecord[0].trim(),
          ItemName: currentRecord[1].trim(),
          Quantity: +currentRecord[2].trim(),
        };
        tmpArr.push(itemToImport);
      }
    }
    return tmpArr;
  }

  private splitLine(line: string, fromText: boolean): string[] {
    let separators: string[];
    if (fromText) {
      separators = ['\t', ' ', '|'];
    } else {
      separators = [','];
    }

    for (const sep of separators) {
      const parts = line
        .split(sep)
        .map((p) => p.trim())
        .filter((p) => p !== '');

      if (parts.length >= 2) {
        return parts;
      }
    }

    return [line.trim()];
  }
}
